import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "text-large fw-bold mr-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_5 = { class: "me-2 fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_7 = { class: "me-2 fw-bold" }
const _hoisted_8 = { class: "d-flex gap-5 align-items-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "d-flex flex-column h-100 bgi-size-cover bgi-position-center",
  style: {"background":"linear-gradient(135deg, #2563EB 0%, #3B82F6 100%)"}
}
const _hoisted_11 = { class: "d-flex flex-column flex-center mt-5" }
const _hoisted_12 = {
  key: 0,
  class: "photo float-start position-absolute z-index-1",
  style: {"top":"70px","left":"290px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill text-primary fs-1" }, null, -1)
const _hoisted_14 = { class: "bg-white bg-opacity-25 rounded-pill py-1 px-3 text-white my-3 fw-bold" }
const _hoisted_15 = { class: "text-white mb-1" }
const _hoisted_16 = { class: "text-white" }
const _hoisted_17 = { class: "d-flex flex-row-fluid justify-content-center px-4" }
const _hoisted_18 = {
  class: /*#__PURE__*/_normalizeClass([
                                        'd-flex',
                                        'align-items-center',
                                        'gap-2',
                                        'bg-succes',
                                        'flex-row',
                                    ])
}
const _hoisted_19 = {
  class: "rounded text-white h-40px w-45px text-center p-2",
  style: {"background":"#0E90DA"}
}
const _hoisted_20 = { class: "d-flex flex-column text-start" }
const _hoisted_21 = { class: "fw-bold fs-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Descripción", -1)
const _hoisted_23 = {
  class: /*#__PURE__*/_normalizeClass([
                                        'd-flex',
                                        'align-items-center',
                                        'gap-2',
                                        'bg-succes',
                                        'flex-row',
                                    ])
}
const _hoisted_24 = {
  class: "rounded text-white h-40px w-45px text-center p-2",
  style: {"background":"#0E90DA"}
}
const _hoisted_25 = { class: "d-flex flex-column text-start" }
const _hoisted_26 = { class: "fw-bold fs-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Descripción", -1)
const _hoisted_28 = {
  key: 0,
  class: "card mb-2 me-6 ms-6 shadow-sm"
}
const _hoisted_29 = { class: "card-header" }
const _hoisted_30 = { class: "card-title" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-4 me-4" }, "Estado", -1)
const _hoisted_33 = { class: "card-toolbar" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm me-4 text-danger text-hover-white px-8 py-2 border border-danger bg-hover-danger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-auto-close": "outside"
}, " Observar ", -1)
const _hoisted_35 = { class: "dropdown-menu w-lg-200px w-xl-350px" }
const _hoisted_36 = { class: "form-group row" }
const _hoisted_37 = { class: "col-sm-12" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, "Observaciones", -1)
const _hoisted_39 = { class: "form-group row" }
const _hoisted_40 = { class: "col-sm-12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Cambiar de estado", -1)
const _hoisted_42 = { class: "d-flex justify-content-between" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg fs-2 text-white me-2" }, null, -1)
const _hoisted_44 = {
  key: 2,
  class: "step-documentation h-100"
}
const _hoisted_45 = {
  key: 1,
  class: "card h-100"
}
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = { class: "card-px text-center py-20 my-10" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill fs-5x mb-4 text-primary" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bold my-10" }, "Este registro no requiere adjuntar documentación alguna.", -1)
const _hoisted_50 = { class: "text-gray-500 fs-5 fw-semibold mb-13" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { class: "text-primary" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left fs-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_sAcademic = _resolveComponent("sAcademic")!
  const _component_sCompetition = _resolveComponent("sCompetition")!
  const _component_sOficial = _resolveComponent("sOficial")!
  const _component_sFiles = _resolveComponent("sFiles")!
  const _component_LineTime = _resolveComponent("LineTime")!
  const _component_PhotoManager = _resolveComponent("PhotoManager")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_UploadFileModal = _resolveComponent("UploadFileModal")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.gblDialogAcrd,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gblDialogAcrd) = $event)),
    class: "bg-light",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    fullscreen: true,
    "show-close": false
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_page_header, {
          icon: _ctx.ArrowLeft,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gblDialogAcrd = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_avatar, {
                size: 32,
                class: "me-3",
                src: _ctx.evento?.logo,
                fit: "contain"
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.evento?.name), 1),
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sport?.name), 1),
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString((_ctx.action == 1) ? _ctx.t('register') : ((_ctx.action == 2) ? _ctx.t('edit') : '')), 1)
            ])
          ]),
          _: 1
        }, 8, ["icon"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("i", {
            class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
            onClick: close
          }, null, 8, _hoisted_9)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_container, {
        style: _normalizeStyle(`height:${_ctx.altura - 250}px;`)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { class: "w-md-300px w-lg-300px w-xl-400px stepper stepper-pills stepper-column stepper-multistep rounded" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.action == 1 || _ctx.action == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_el_button, {
                          size: "large",
                          circle: "",
                          class: "border-primary shadow",
                          onClick: _ctx.onDialogPhoto
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode(_component_el_image, {
                    style: {"width":"200px","height":"234px"},
                    class: "bg-white rounded border border-primary border-4 shadow",
                    src: `${_ctx.REPO}/${_ctx.photo?.ruta}`,
                    fit: 'fill'
                  }, null, 8, ["src"]), [
                    [_directive_loading, _ctx.loaderPhoto]
                  ]),
                  _createElementVNode("h6", _hoisted_14, " ID: " + _toDisplayString(_ctx.rowAcrd?.idacreditation), 1),
                  _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.rowAcrd?.firstname), 1),
                  _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.rowAcrd?.lastname) + " " + _toDisplayString(_ctx.rowAcrd?.surname), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.action == 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.typeRegister == 'D')
                          ? (_openBlock(), _createBlock(_component_el_segmented, {
                              key: 0,
                              modelValue: _ctx.activeStep,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeStep) = $event)),
                              options: _ctx.options,
                              direction: 'vertical',
                              size: 'small',
                              class: _normalizeClass(`bg-white w-100 rounded p-0 h-${_ctx.alturaSegment}px`)
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(`${scope.item.icon} fs-2x text-white`)
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(scope.item.label), 1),
                                    _hoisted_22
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "class"]))
                          : (_openBlock(), _createBlock(_component_el_segmented, {
                              key: 1,
                              modelValue: _ctx.activeStep,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeStep) = $event)),
                              options: _ctx.optionsOT,
                              direction: 'vertical',
                              size: 'small',
                              class: _normalizeClass(`bg-white w-100 rounded p-0 h-${_ctx.alturaSegment}px`)
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("span", _hoisted_24, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(`${scope.item.icon} fs-2x text-white`)
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(scope.item.label), 1),
                                    _hoisted_27
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "class"]))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, { class: "d-flex flex-column" }, {
            default: _withCtx(() => [
              (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 8)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.rowAcrd?.checkstatus)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("span", {
                                class: _normalizeClass(`badge badge-${_ctx.rowAcrd?.checkClass}`)
                              }, _toDisplayString(_ctx.rowAcrd?.checkstatus), 3)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_el_form, {
                            ref: "formRec",
                            model: _ctx.form,
                            "status-icon": "",
                            rules: _ctx.rules,
                            class: "form form-label-right p-6 bg-white"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _hoisted_38,
                                  _createVNode(_component_el_form_item, { prop: "message" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.form.message,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event)),
                                        type: "textarea",
                                        placeholder: "Ingrese aquí las observaciones del rechazo de la participación",
                                        rows: 4,
                                        maxlength: "100",
                                        "show-word-limit": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _hoisted_41,
                                  _createVNode(_component_el_form_item, { prop: "checkdoc" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.form.checkdoc,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.checkdoc) = $event)),
                                        placeholder: "Seleccionar",
                                        class: "w-100"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.id,
                                              label: item.name,
                                              value: item.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_el_button, {
                                  class: "fw-normal",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetForm(_ctx.formRec)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Cancelar")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  loading: _ctx.loading,
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitForm(_ctx.formRec))),
                                  class: "fw-normal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Guardar")
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ]),
                        (_ctx.rowAcrd?.checkdoc != 1)
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: _ctx.aproved,
                              type: "success",
                              class: "fw-normal"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_43,
                                _createTextVNode(" Aprobar ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])), [
                              [_directive_loading, _ctx.loading]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createBlock(_component_el_main, { class: "py-0" }, {
                default: _withCtx(() => [
                  (_ctx.typeRegister == 'D')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.activeStep == 0)
                          ? (_openBlock(), _createBlock(_component_sAcademic, {
                              key: 0,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation
                            }, null, 8, ["idacrd"]))
                          : _createCommentVNode("", true),
                        (_ctx.activeStep == 1)
                          ? (_openBlock(), _createBlock(_component_sCompetition, {
                              key: 1,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              idevent: _ctx.rowAcrd?.idevent,
                              idsport: _ctx.rowAcrd?.idsport
                            }, null, 8, ["idacrd", "idevent", "idsport"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.activeStep == 0)
                          ? (_openBlock(), _createBlock(_component_sOficial, {
                              key: 0,
                              ref: "childComponentRef",
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              "list-functions": _ctx.listFunctions,
                              sport: _ctx.sport
                            }, null, 8, ["idacrd", "list-functions", "sport"]))
                          : _createCommentVNode("", true)
                      ], 64)),
                  (_ctx.activeStep == _ctx.totalSteps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_ctx.listTypeFile.length > 0)
                          ? (_openBlock(), _createBlock(_component_sFiles, {
                              key: 0,
                              idacrd: _ctx.rowAcrd?.idacreditation,
                              target: 'accreditation'
                            }, null, 8, ["idacrd"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _hoisted_48,
                                  _hoisted_49,
                                  _createElementVNode("p", _hoisted_50, [
                                    _createElementVNode("span", null, [
                                      _createTextVNode("Si el registro no requiere adjuntar documentación "),
                                      _hoisted_51,
                                      _createTextVNode("por favor haga clic en el botón "),
                                      _createElementVNode("b", _hoisted_52, _toDisplayString(_ctx.activeStep ==
                                                _ctx.totalSteps ? 'Guardar' : _ctx.t('next')), 1),
                                      _createTextVNode(".")
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeStep == 3)
                    ? (_openBlock(), _createBlock(_component_LineTime, {
                        key: 3,
                        id: _ctx.rowAcrd?.idacreditation,
                        target: 'accreditation'
                      }, null, 8, ["id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeStep == 4)
                    ? (_openBlock(), _createBlock(_component_PhotoManager, {
                        key: 4,
                        idperson: _ctx.rowAcrd?.idperson,
                        idacrd: _ctx.rowAcrd.idacreditation
                      }, null, 8, ["idperson", "idacrd"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })), [
                [_directive_loading, _ctx.loader]
              ]),
              (_ctx.action == 1)
                ? (_openBlock(), _createBlock(_component_el_footer, {
                    key: 1,
                    class: "px-6 h-auto text-end"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.activeStep > 0)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: _ctx.backStep,
                            class: "fw-normal"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_53,
                              _createTextVNode(" " + _toDisplayString(_ctx.t('back')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        type: (_ctx.activeStep == _ctx.totalSteps) ? 'success' : 'primary',
                        onClick: _ctx.getFormData,
                        loading: _ctx.loader,
                        class: "fw-normal"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.activeStep == _ctx.totalSteps ? _ctx.t('save') : _ctx.t('next')) + " ", 1),
                          _createElementVNode("i", {
                            class: _normalizeClass(`bi bi-${_ctx.activeStep == _ctx.totalSteps ? 'person-check' : 'chevron-right'} fs-4 text-white`)
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["type", "onClick", "loading"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_UploadFileModal, {
        ref: "uploadPhotoRef",
        extens: '.png, .jpg, jpeg',
        maxFileSizeMB: 1,
        "params-upload": _ctx.paramsUpload,
        allowedMIMEs: ['image/png', 'image/jpg', 'image/jpeg'],
        onUploadResponse: _ctx.uploadResponse
      }, null, 8, ["extens", "params-upload", "onUploadResponse"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened", "onClosed"]))
}